import React from "react";

const FreeSections = () => {
  return (
    <>
      <div className="flex flex-col px-4 justify-center md:px-0 md:flex-row my-8 md:mt-24">
        <div className="flex flex-col md:flex-row items-center justify-between md:w-3/4">
          <div className="flex flex-col w-full md:w-1/2 md:order-2">
            <h2 className="section-heading text-agrandir text-5xl mb-4">
              Put Standards to Work Easier and Faster
            </h2>
            <h3 className="section-body">
              Every second matters on the job. With this searchable solution,
              you’ll find the right content exactly when you need it. We create
              and revise content components based on real-world application,
              feedback and insights. 
            </h3>
          </div>

          <div className="w-full md:w-2/6">
            <img
              className="w-full my-8"
              src="images/original-easy-to-understand.png"
              alt="Apply standards easier"
            />
          </div>
        </div>
      </div>

      <div className="flex flex-col px-4 justify-center md:px-0 md:flex-row my-8 md:mt-2">
        <div className="flex flex-col md:flex-row items-center justify-between md:w-3/4">
          <div className="flex flex-col w-full md:w-1/2">
            <h2 className="section-heading text-agrandir text-5xl mb-4">
              The “+” Adds Value
            </h2>
            <h3 className="section-body">
              Standards and guides are just the beginning. You get exclusive
              access to original how-to articles and videos, downloadable
              templates and more—along with learning opportunities to help you
              thrive on each project and in your career. 
            </h3>
          </div>

          <div className="w-full md:w-2/6">
            <img
              className="w-full my-8"
              src="images/apply-standards-easier.png"
              alt="Origional easy to understand content"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default FreeSections;
